/* STACKd Supplements Theme — theme.js */
(function() {
  'use strict';

  /* ---- Mobile Nav ---- */
  function initMobileNav() {
    var toggle = document.querySelector('.site-header__menu-toggle');
    var nav = document.getElementById('mobile-nav');
    var close = document.querySelector('.mobile-nav__close');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      nav.hidden = false;
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    });

    function closeNav() {
      nav.hidden = true;
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    if (close) close.addEventListener('click', closeNav);
    nav.addEventListener('click', function(e) {
      if (e.target === nav) closeNav();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !nav.hidden) closeNav();
    });
  }

  /* ---- Hero Slideshow ---- */
  function initHeroSlideshow() {
    var sliders = document.querySelectorAll('.hero-slideshow');
    sliders.forEach(function(slider) {
      var slides = slider.querySelectorAll('.hero-slideshow__slide');
      var dots = slider.querySelectorAll('.hero-slideshow__dot');
      var prevBtn = slider.querySelector('.hero-slideshow__arrow--prev');
      var nextBtn = slider.querySelector('.hero-slideshow__arrow--next');
      if (slides.length < 2) return;

      var current = 0;
      var autoplay = slider.dataset.autoplay !== 'false';
      var speed = parseInt(slider.dataset.speed || '5') * 1000;
      var timer;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function startTimer() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(function() { goTo(current + 1); }, speed);
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); startTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); startTimer(); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); startTimer(); });
      });

      startTimer();
    });
  }

  /* ---- Best Sellers Tabs ---- */
  function initBestSellersTabs() {
    var sections = document.querySelectorAll('.best-sellers');
    sections.forEach(function(section) {
      var tabs = section.querySelectorAll('.best-sellers__tab');
      var panels = section.querySelectorAll('.best-sellers__panel');
      tabs.forEach(function(tab, i) {
        tab.addEventListener('click', function() {
          tabs.forEach(function(t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
          panels.forEach(function(p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('is-active');
        });
      });
    });
  }

  /* ---- Testimonials Slider ---- */
  function initTestimonials() {
    var sliders = document.querySelectorAll('.testimonials__slider');
    sliders.forEach(function(slider) {
      var slides = slider.querySelectorAll('.testimonials__slide');
      var dots = slider.querySelectorAll('.testimonials__dot');
      var prev = slider.querySelector('.testimonials__arrow--prev');
      var next = slider.querySelector('.testimonials__arrow--next');
      if (slides.length < 2) return;

      var current = 0;
      var timer;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function startTimer() {
        clearInterval(timer);
        timer = setInterval(function() { goTo(current + 1); }, 6000);
      }

      if (prev) prev.addEventListener('click', function() { goTo(current - 1); startTimer(); });
      if (next) next.addEventListener('click', function() { goTo(current + 1); startTimer(); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); startTimer(); });
      });

      startTimer();
    });
  }

  /* ---- Cart AJAX ---- */
  function initCart() {
    document.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) {
        e.preventDefault();
        var key = removeBtn.dataset.key;
        if (!key) return;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function() { window.location.reload(); });
      }

      var decreaseBtn = e.target.closest('.quantity-selector__btn[data-action="decrease"]');
      if (decreaseBtn) {
        var input = decreaseBtn.closest('.quantity-selector').querySelector('.quantity-selector__input');
        if (input) {
          var val = Math.max(0, parseInt(input.value) - 1);
          input.value = val;
        }
      }

      var increaseBtn = e.target.closest('.quantity-selector__btn[data-action="increase"]');
      if (increaseBtn) {
        var inp = increaseBtn.closest('.quantity-selector').querySelector('.quantity-selector__input');
        if (inp) inp.value = parseInt(inp.value) + 1;
      }
    });
  }

  /* ---- Add to Cart ---- */
  function initAddToCart() {
    var forms = document.querySelectorAll('[data-type="add-to-cart-form"]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'ADDING...';

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status) {
            btn.textContent = 'ERROR';
            setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2000);
          } else {
            btn.textContent = 'ADDED!';
            updateCartCount();
            setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1500);
          }
        })
        .catch(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        });
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEl = document.querySelector('.site-header__cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            var cartIcon = document.querySelector('.site-header__cart');
            if (cartIcon) {
              var span = document.createElement('span');
              span.className = 'site-header__cart-count';
              span.textContent = cart.item_count;
              cartIcon.appendChild(span);
            }
          } else {
            countEl.textContent = cart.item_count;
          }
        } else if (countEl) {
          countEl.remove();
        }
      });
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function() {
    initMobileNav();
    initHeroSlideshow();
    initBestSellersTabs();
    initTestimonials();
    initCart();
    initAddToCart();
  });

})();
